import { Component, input, output } from "@angular/core";
import { RdxLabelDirective } from "@radix-ng/primitives/label";
import { RdxSwitchRootDirective, RdxSwitchThumbDirective } from "@radix-ng/primitives/switch";

@Component({
  selector: "app-switch",
  imports: [RdxLabelDirective, RdxSwitchRootDirective, RdxSwitchThumbDirective],
  template: `
    <label class="switch subtitle-3" rdxLabel [htmlFor]="id()">
      <button
        class="switch__root"
        [id]="id()"
        [checked]="checked()"
        [attr.aria-label]="label()"
        rdxSwitchRoot
        (onCheckedChange)="toggleSwitch.emit($event)"
      >
        <span class="switch__thumb" rdxSwitchThumb></span>
      </button>
      <span class="switch__label">
        {{ label() }}
      </span>
    </label>
  `,
  styles: `
    .switch {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .switch__label {
      display: block;
      width: 100%;
      color: #fff;
    }

    .switch__root {
      display: block;
      position: relative;
      width: 55px;
      height: 26px;
      border-radius: 13px;
      border: 2px solid #071213;
      background-color: #fff;
      padding: 0;
      transition: background-color 0.5s ease;

      &:focus {
        outline: none;
        box-shadow:
          0 0 0 2px #fff,
          0 0 0 4px #071213;
      }

      &[data-state="checked"] {
        background-color: #05bf8e;
      }

      &[data-disabled="true"] {
        cursor: not-allowed;
      }
    }

    .switch__thumb {
      position: absolute;
      top: 5px;
      left: 4px;
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 81px;
      background: #071213;
      transition: left 0.5s ease;

      &[data-state="checked"] {
        left: 26px;
      }

      .Label {
        color: yellow;
        font-size: 15px;
        line-height: 1;
        display: flex;
        align-items: center;
      }
    }
  `,
})
export class Switch {
  id = input.required<string>();
  label = input.required<string>();
  checked = input.required<boolean>();

  toggleSwitch = output<boolean | undefined>();
}
